import AlignCenter from "../../icons/AlignCenter";
import AlignLeft from "../../icons/AlignLeft";
import AlignRight from "../../icons/AlignRight";

export const ALIGNMENT_OPTIONS = [
  { icon: AlignLeft, value: "left" },
  { icon: AlignCenter, value: "center" },
  { icon: AlignRight, value: "right" },
];

export const BOOLEAN_OPTIONS = [
  { label: "Yes", i18n: "yes", value: true },
  { label: "No", i18n: "no", value: false },
];

export const ICON_SIZE_OPTIONS = [
  { label: "S", value: 16 },
  { label: "M", value: 20 },
  { label: "L", value: 24 },
];

export const TEXT_SIZE_OPTIONS = [
  { label: "S", value: 16 },
  { label: "M", value: 20 },
  { label: "L", value: 24 },
];

export const LINE_WEIGHT_OPTIONS = [
  { label: "S", value: 1 },
  { label: "M", value: 2 },
  { label: "L", value: 3 },
];

export const LINE_WIDTH_OPTIONS = [
  { label: "S", value: 35 },
  { label: "M", value: 50 },
  { label: "L", value: 100 },
];
